import { atom } from "recoil";
import { IOfficeDepartment, SelectedRowsToDelete } from "../types";

export const addStateDept = atom({
  key: "addDepartment",
  default: false,
});

export const savingDepartment = atom({
  key: "savingDepartment",
  default: false,
});

export const rowForEditDepartment = atom<IOfficeDepartment | undefined>({
  key: "rowForEditDepartment",
  default: undefined,
});

export const selectedRowsStateDept = atom<SelectedRowsToDelete>({
  key: "selectedRowsStateDept",
  default: [],
});

export const editStateDepartment = atom({
  key: "editStateDepartment",
  default: false,
});

export const editRowDepartmentId = atom({
  key: "editRowDepartmentId",
  default: [],
});

export const hasDepartmentName = atom({
  key: "hasDepartmentName",
  default: false,
});
